export default "__VITE_ASSET__BI_b0t8G__"